import enIN from "./en-IN.json";

class Locales {
  // eslint-disable-next-line class-methods-use-this
  t(key) {
    return enIN[key] || key;
  }
}

const Locale = new Locales();

export default Locale;
